export default __webpack_public_path__ + "static/media/search.20f2a430.svg";